import {Spin} from 'antd';
import React, {useEffect} from 'react';

import {CONSTANTS} from '../../services';

import './oauth2PopupPage.scss';

interface OAuth2PopupPageProps {
  stateKey: string;
  messageResponseType: string;
}

export function HSOAuth2PopupPage() {
  return (
    <OAuth2PopupPage
      stateKey={CONSTANTS.hs_oauth2_state_key}
      messageResponseType={CONSTANTS.hs_oauth2_message_response}
    />
  )
}

export function SFOAuth2PopupPage() {
  return (
    <OAuth2PopupPage
      stateKey={CONSTANTS.sf_oauth2_state_key}
      messageResponseType={CONSTANTS.sf_oauth2_message_response}
    />
  )
}

function OAuth2PopupPage({stateKey, messageResponseType}: OAuth2PopupPageProps) {
  const queryToObject = (query: string) => {
    const parameters = new URLSearchParams(query);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return Object.fromEntries(parameters.entries());
  };

  const checkState = (receivedState: string) => {
    const state = sessionStorage.getItem(stateKey);
    return state === receivedState;
  };

  useEffect(() => {
    const payload = queryToObject(window.location.search.split('?')[1]);
    const state = payload?.state;
    const error = payload?.error;
    if (!window.opener) {
      throw new Error('No window opener');
    }

    if (error) {
      window.opener.postMessage({
        type: messageResponseType,
        error: decodeURI(error) || 'OAuth error: An error has occured.',
      });
    } else if (checkState(state)) {
      window.opener.postMessage({
        type: messageResponseType,
        payload,
      });
    } else {
      window.opener.postMessage({
        type: messageResponseType,
        error: 'OAuth error: State mismatch.',
      });
    }
  }, [stateKey, messageResponseType]);

  return (
    <div className="oauth2-page__spinner-wrapper">
      <Spin size="large" tip="Authorizing..." />
    </div>
  );
}
